export const SIDEBAR_SET_STATE = 'SIDEBAR_SET_STATE';
